import { Component, createRef } from 'react';
import styled from 'styled-components';
import Modal from '../common/modal';
import { theme } from '../../styles';
import { DOMUtils, enableAutoExpand } from '../../common';

class WRModalsPrompt extends Component {
  state = {
    value: this.props.value || '',
    errors: this.props.errors || null,
  };

  constructor(props) {
    super(props);
    this.textareaRef = createRef();
    this.valueRef = createRef();
  }

  componentDidUpdate() {
    if (this.textareaRef.current) {
      enableAutoExpand($(this.textareaRef.current));
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      value: newProps.value || '',
      errors: newProps.errors || null,
    });
    const { allowMultiline } = newProps.options || {};

    if (allowMultiline) {
      DOMUtils.setFocusToEndWithDelay(this.textareaRef.current, newProps.value || this.props.value || '');
    } else {
      DOMUtils.setFocusToEndWithDelay(this.valueRef.current, newProps.value || this.props.value || '');
    }
  }

  render() {
    let { allowMultiline, disableSaveOnEnter, maxLength, wrapHeader } = this.props.options || {};
    if (allowMultiline) disableSaveOnEnter = true;
    const { onClose, placeholder, show, text } = this.props;

    const inputProps = {
      className: 'form-input-text',
      onChange: this.onValueChange,
      placeholder,
      ref: this.valueRef,
      style: allowMultiline ? { display: 'none' } : null,
      type: 'text',
      value: this.state.value,
    };

    const textareaProps = {
      className: 'form-input-text',
      onChange: this.onValueChange,
      placeholder,
      ref: this.textareaRef,
      rows: '1',
      style: allowMultiline ? null : { display: 'none' },
      value: this.state.value,
    };

    if (maxLength) {
      inputProps.maxLength = maxLength;
      textareaProps.maxLength = maxLength;
    }

    return (
      <Modal
        show={show}
        title={text}
        onSave={this.onSave}
        onClose={onClose}
        disableSaveOnEnter={disableSaveOnEnter}
        wrapHeader={wrapHeader}
      >
        <div className="my-form">
          <div className="form-field">
            <div>
              {
                <>
                  {/** Both nodes must be in the DOM for setFocusToEndWithDelay */}
                  <input {...inputProps} />
                  <textarea {...textareaProps} />
                  {maxLength && <CharCounter>{`${this.state.value.length}/${maxLength} characters`}</CharCounter>}
                </>
              }
              {this.state.errors && (
                <div style={{ color: theme.color.error, paddingTop: '1em' }}>{this.state.errors}</div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  onValueChange = (e) => {
    this.setState({
      value: e.target.value,
      errors: null,
    });
  };

  //  return true if errors in input exist
  checkForErrors = () => {
    //  check for errors if errorCheck supplied
    if (this.props.options && this.props.options.errorCheck) {
      const errors = this.props.options.errorCheck(this.state.value);
      if (errors) {
        this.setState({ errors });
        return true;
      }
    }
    return false;
  };

  onSave = (onFinish) => {
    if (this.checkForErrors()) {
      if (typeof onFinish === 'function') onFinish();
      return;
    }
    if (typeof this.props.onSave === 'function') {
      this.props.onSave(this.state.value);
    }

    // For now, let's close the modal and call onFinish synchronously to simplify the WRModals API. May revisit later.
    if (typeof onFinish === 'function') onFinish();
    this.props.onClose();
  };
}

export default WRModalsPrompt;

const CharCounter = styled.p`
  text-align: right;
  color: #808080;
  font-size: 12px;
  margin: 0;
`;
